import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal, MaskedLines, Eyebrow } from "@/components/Motion";

const NotFound = () => (
  <>
    <Seo title="Page Not Found — NEXREQ UAE & GCC" siteName="NEXREQ" description="The page you are looking for could not be found." />
    <section className="flex min-h-screen items-center bg-obsidian" data-testid="not-found-page">
      <div className="nx-container py-40">
        <Reveal>
          <Eyebrow>Error 404</Eyebrow>
        </Reveal>
        <h1 className="mt-8 font-heading text-5xl font-light leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-7xl">
          <MaskedLines onLoad delay={0.2} lines={["This Page Has", "Moved On."]} />
        </h1>
        <Reveal delay={0.5}>
          <p className="mt-7 max-w-md leading-relaxed text-white/55">
            The page you are looking for does not exist or has been relocated. These destinations
            are always open.
          </p>
        </Reveal>
        <Reveal delay={0.65}>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/" className="nx-btn-primary" data-testid="notfound-home-btn">
              Return Home <ArrowRight size={15} />
            </Link>
            <Link to="/jobs" className="nx-btn-outline" data-testid="notfound-jobs-btn">
              Explore Opportunities
            </Link>
            <Link
              to="/contact"
              className="self-center text-sm text-white/60 underline-offset-4 transition-colors hover:text-emerald-400 hover:underline"
              data-testid="notfound-contact-link"
            >
              Contact NEXREQ
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default NotFound;
